<template>
  <div class="product-container">
    <div class="product-heading">
      <div class="mb5">
        <div class="h4 weight-400 cl-accent serif overflow-wrap-anywhere">
          {{ product.name | htmlDecode }}
        </div>
        <div class="error" v-if="product.errors && Object.keys(product.errors).length > 0">
          {{ product.errors | formatProductMessages }}
        </div>
      </div>
      <div>
        <div v-if="isOnline && product.totals">
          <span class="h4 cl-error float-right" v-if="product.totals.discount_amount">
            {{
              (product.totals.row_total - product.totals.discount_amount + product.totals.tax_amount)
                | price(storeView)
            }}
          </span>
          <span class="price-original h5 float-right" v-if="product.totals.discount_amount">
            f {{ product.totals.row_total_incl_tax | price(storeView) }}</span>
          <span v-if="!product.totals.discount_amount" class="h4">
            e {{ product.totals.row_total_incl_tax | price(storeView) }}</span>
        </div>
        <div v-else>
          <span v-if="!product.special_price" class="h4 float-right price">{{ intervalPrice | price(storeView) }}</span>
        </div>
      </div>
    </div>
    <div class="row pl30 pt0 pr30 between-xs product-info">
      <div class="blend overflow-hidden">
        <product-image :image="image" class="product-image product-image-checkout" />
      </div>
      <div class="col-xs ml10">
        <!--        Row for name-->
        <div class="row">
          <!--            Product options-->
          <div class="col-md-6 col-xs-6 product-options">
            <div class="h5 cl-bg-tertiary options" v-if="product.totals && product.totals.options">
              <div v-for="opt in product.totals.options" :key="opt.label">
                <span class="opn">{{ $t(opt.label + '_filter') }}: </span>
                <span class="opv" v-html="opt.value" />
              </div>
            </div>
            <div class="h5 cl-bg-tertiary options product-options" v-else-if="product.options">
              <div v-for="opt in product.options" :key="opt.label">
                <span class="opn">{{ $t(opt.label + '_filter') }}: </span>
                <span class="opv" v-html="opt.value" />
              </div>
            </div>
            <div>
              <div>
                <span class="h5 cl-secondary">
                  {{ $t('Qty') }}
                  <span>
                    {{ product.qty }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!--            Product price-->
        </div>
      </div>
    </div>
    <div class="additional-services">
      <div v-for="service in product.selectedServices" :key="service.id" class="row pb0 pt0 pl30 pr30 to">
        <div class="blend" />
        <div class="col-xs ml10 h4 weight-400 cl-accent serif">
          {{ service.name }}
        </div>
        <div class=" align-right cl-accent h4">
          {{ service.price | price(storeView) }}
        </div>
      </div>
    </div>
    <div class="line" />
  </div>
</template>

<script>
import { Product } from '@vue-storefront/core/modules/checkout/components/Product';
import { onlineHelper } from '@vue-storefront/core/helpers';
import ProductImage from 'theme/components/core/ProductImage';
import { currentStoreView } from '@vue-storefront/core/lib/multistore';
import { Logger } from '@vue-storefront/core/lib/logger';

export default {

  mixins: [Product],
  components: {
    ProductImage
  },
  computed: {
    platformTotals () {
      return this.$store.getters['cart/getPlatformTotals'];
    },
    storeView () {
      return currentStoreView();
    },
    isOnline () {
      return onlineHelper.isOnline;
    },
    image () {
      return {
        loading: this.thumbnail,
        src: this.thumbnail
      };
    },
    dateFrom: {
      get () {
        return this.$store.getters['reservations/getCurrentDates'].from;
      },
      set (date) {
        return this.$store.dispatch('reservations/setDateFrom', date);
      }
    },
    intervalPrice () {
      return this.getIntervalPrice(this.$store.getters['cart/getPlatformTotals']) || '';
    },
    dateTo: {
      get () {
        return this.$store.getters['reservations/getCurrentDates'].to;
      },
      set (date) {
        return this.$store.dispatch('reservations/setDateTo', date);
      }
    }
  },
  methods: {
    getIntervalPrice (platformTotals) {
      if (!platformTotals) {
        Logger.error('totals', 'totals arent accessible', platformTotals)();
        return this.product.price;
      }

      const totalItems = platformTotals.items;

      if (!totalItems) {
        return this.product.price;
      }

      const child = this.product.configurable_children.find((configurableChildren) => {
        return configurableChildren.sku === this.product.sku;
      });

      if (!child) {
        Logger.error('intervalPrice', 'unable to match totals and product.. sku mismatch', this.product.configurable_children)();
        return this.product.price;
      }

      for (const item of totalItems) {
        const result = child.items.find((childItem) => {
          return childItem.id === item.item_id;
        });
        // if there's an item in the child that has the same id as
        // one of the objects in platform.totals, then take it's price
        if (result) {
          return item.row_total;
        }
      }
      return this.product.price;
    }
  }
};
</script>

<style lang='scss' scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$color-matterhorn: color(matterhorn);

.price-original {
  text-decoration: line-through;
}
.justify-self-end {
  justify-self: end;
}
.float-right{
  float: right;
}

.color-matterhorn {
  color: $color-matterhorn;
}

.overflow-wrap-anywhere {
  overflow-wrap: anywhere;
}

.overflow-hidden {
  overflow: hidden;
}

.blend {
  flex: 0 0 150px;
}

.product-heading {
  display: flex;
  justify-content: space-between;
  padding: 0 30px 1rem 30px;
}

.product-options {
  display: grid;
  gap: 0.5rem;
}

.additional-services {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.product-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.line {
  margin: 20px 0;
  align-self: center;
  width: 90%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
}
@media (max-width: 500px) {
  .line {
    width: 100%;
  }
  .product-heading {
    padding: 0 0 1rem 0;
  }
  .product-info {
    padding-inline: 0;
  }
  .product-container {
    padding-inline: 15px;
  }
}

.price {
  width: max-content;
}
</style>
